<button [type]="buttonType" (debounceclicked)="onClick($event)" debounceClick [debouncetime]="100" [disabled]="disabled" *ngIf="!link"
    class="tw-w-full tw-flex tw-flex-row tw-items-center tw-justify-center tw-gap-x-2 tw-btn tw-btn-{{color}} tw-btn-{{size}} {{type}} {{cssClass}}">
    <ng-content select="[prefixIcon]"></ng-content>
    {{text}}
    <ng-content select="[postfixIcon]"></ng-content>
</button>
<a role="button" [routerLink]="link" *ngIf="link" [ngClass]="{'!p-0': type === 'link'}"
    class="tw-w-full tw-flex tw-flex-row tw-items-center tw-justify-center tw-gap-x-2 tw-btn tw-btn-{{color}} tw-btn-{{size}} {{type}} {{cssClass}} "
    [ngClass]="{'hover:!tw-underline': type === 'link'}">
    <ng-content select="[prefixIconLink]"></ng-content>
    {{text}}
    <ng-content select="[postfixIconLink]"></ng-content>
</a>